import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react-lite';
import styled from 'styled-components';
import {Divider} from 'antd';
import {EmptyStateKeDetail} from './emptyStateKe';

import moment from 'moment';
import {SkeletonHorizontalLoaderGray} from '@/components/common-components/components';
import {useState, useEffect} from 'react';
import {isPublicKeywordResearcherV2} from '@/utils/url';

export const CurrentAds = observer(() => {
  const {settings: {customer: {setAuthModal}}} = useStore('');
  const {keywordResearcherV2: {keywordDetails: {getOrganicPaidHistoryData, loadingOrganicPaidHistoryDetails}}} = useStore('');
  const data = getOrganicPaidHistoryData?.paidRankings?.paidSerpsByTerm?.length ? getOrganicPaidHistoryData?.paidRankings?.paidSerpsByTerm : [];
  const [dataSlice, setDataSlice] = useState([]);

  useEffect(() => {
    setDataSlice(data?.slice(0, 6));
  }, [data?.length]);

  return (
    <Container>
      {loadingOrganicPaidHistoryDetails ?
        <CardsContainer>
          {[1, 2, 3, 4, 5, 6]?.map((item, index) => {
            return <Box key={`ads_key_${index}`}>
              <div style={{height: '90px'}}>
                <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} />
                <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'} />
                <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} />
              </div>
              <Divider type='horizontal' style={{background: '#E8E8E8', margin: '9px 0'}}/>
              <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'} />
            </Box>;
          })}
        </CardsContainer> : <>
          {!loadingOrganicPaidHistoryDetails && data?.length ? <CardsContainer>
            {dataSlice?.map((item, index) => {
              return <Box key={`ads_key_${index}`}>
                <div style={{height: '90px'}}>
                  <BoxTitle>{item?.title}</BoxTitle>
                  <BoxLink href={item?.url}>{item?.url}</BoxLink>
                  <Description dangerouslySetInnerHTML={{__html: item?.body}} />
                </div>
                <Divider type='horizontal' style={{background: '#E8E8E8', margin: '9px 0'}}/>
                <IndexDate>Indexed: {item?.dateSearched ? moment(item?.dateSearched)?.format('DD MMMM, YYYY') : ''}</IndexDate>
              </Box>;
            })}
            <BoxEmpty />
            <BoxEmpty />
            <BoxEmpty />
            <BoxEmpty />
            <BoxEmpty />
          </CardsContainer> :
            <EmptyStateKeDetail imgText={'/img/backgroundfasearch.svg'} icon={true} text={'Current ads data is unavailable or missing.'} description = {'Data not found.'}/>

          }
          {data?.length > 6 && data?.length !== dataSlice?.length && <div style={{width: '100%'}}> <ButtonWrapperLoad onClick={()=> {
            if (isPublicKeywordResearcherV2()) {
              setAuthModal(true, false);
            } else {
              setDataSlice(dataSlice => [...dataSlice, ...data.slice(dataSlice?.length, dataSlice?.length + 6)]);
            }
          }}> {`load ${data?.length - dataSlice?.length} more ads`} </ButtonWrapperLoad></div>}

        </>}
    </Container>
  );
});

const Container = styled.div`
  margin-top: 15px;
`;

const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
`;

const ButtonWrapperLoad = styled.div`
  margin: auto !important;
  margin-top: -10px !important;
  margin-bottom:20px !important;
  display: flex;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  line-height: 17px;
  color: #2D6CCA;
  &:hover{
    color: #032e70
  }
`;

const Box = styled.div `
  width: 370px;
  height: 165px;
  background: #F9F9FB;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 20px;
  @media screen and (max-width: 800px) {
    width: 100% !important;
  }
`;

const BoxEmpty = styled.div`
  width: 370px;
`;

const BoxTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #144198;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const BoxLink = styled.a`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #0C872F;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  white-space: nowrap;
  margin-top: 3px;
`;

const Description = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #4E5156;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
  margin-top: 9px;
  svg {
    height: 16px;
    width: 16px;
  }
`;

const IndexDate = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #4E5156;
  text-overflow: ellipsis;
  overflow: hidden;
`;
